import type { ReactNode } from 'react';
import { cn } from './cn';

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  maxWidth?: 'sm' | 'md' | 'lg';
  scroll?: boolean;
  className?: string;
}

const maxWidths = {
  sm: 'md:w-[400px]',
  md: 'md:w-[500px]',
  lg: 'md:w-[600px]',
};

export const Modal = ({
  children,
  isOpen,
  maxWidth = 'md',
  scroll = false,
  className,
}: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 z-30 grid content-center w-full h-full p-5 bg-text/70 backdrop-blur-sm md:p-7">
      <div
        className={cn(
          'brand-panel w-full max-w-full mx-auto',
          maxWidths[maxWidth],
          scroll && 'overflow-y-scroll',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};
